import { render, staticRenderFns } from "./GoodsAttribute.vue?vue&type=template&id=0aa2c425"
import script from "./GoodsAttribute.vue?vue&type=script&lang=js"
export * from "./GoodsAttribute.vue?vue&type=script&lang=js"
import style0 from "./GoodsAttribute.vue?vue&type=style&index=0&id=0aa2c425&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa2c425')) {
      api.createRecord('0aa2c425', component.options)
    } else {
      api.reload('0aa2c425', component.options)
    }
    module.hot.accept("./GoodsAttribute.vue?vue&type=template&id=0aa2c425", function () {
      api.rerender('0aa2c425', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/components/GoodsAttribute.vue"
export default component.exports